export default ({ store, route }) => {
  if (process.client) {
    // Don't know if we can do this, but the extra call to BE every request is not good for site speed
    if (route.fullPath.includes('/comfort-club') && !route.fullPath.includes('/login')) {
      store.dispatch('account/getAccount')
    }
    store.dispatch('yotpo/syncVotesWithLocalStorage')
  }
}
